import { createActionGroup, props } from "@ngrx/store";

import { Pipeline } from "./pipeline.state";

export const pipelineActions = createActionGroup({
  source: "Pipeline",
  events: {
    "Find For Sample": props<{ sampleId: string }>(),
    "Find For Sample Success": props<{ pipelines: Pipeline[] }>(),
    "Find For Sample Failure": props<{ error: string }>(),
  },
});